document.addEventListener("DOMContentLoaded", function () {
  const productGridContainer = document.getElementById("ProductGridContainer");

  if (!productGridContainer) {
    console.error("ProductGridContainer not found!");
    return;
  }

  productGridContainer.addEventListener("click", function (event) {
    if (event.target.closest("[data-load-more-button]")) {
      const loadMoreButton = event.target.closest("[data-load-more-button]");
      const loadMoreText = document.querySelector("[data-load-more-text]");
      const loadingIcon = document.querySelector("[data-load-more-icon]");
      const nextLinkInput = document.querySelector("[data-next-link]");
      const allPagesInput = document.querySelector("[data-all-pages]");
      const thisPageInput = document.querySelector("[data-this-page]");
      const collectionUrlInput = document.querySelector(
        "[data-collection-url]"
      );

      const totalPages = parseInt(allPagesInput.value);
      const currentPage = parseInt(thisPageInput.value);
      const dataCollectionUrl = collectionUrlInput.value;

      loadMoreButton.setAttribute("disabled", true);
      loadMoreText.innerHTML = "Loading...";
      loadingIcon.classList.remove("hidden");

      const nextUrl = nextLinkInput.value;
      const currentPageNew = currentPage + 1;
      const nextCollection = currentPage + 2;

      fetch(nextUrl)
        .then((response) => response.text())
        .then((responseHTML) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(responseHTML, "text/html");
          const newItems = doc.getElementById("ProductGrid").innerHTML;
          productGridContainer.querySelector("#ProductGrid").innerHTML +=
            newItems;

          nextLinkInput.value = `${dataCollectionUrl}?page=${nextCollection}`;
          thisPageInput.value = currentPageNew;

          if (currentPageNew < totalPages) {
            loadMoreButton.removeAttribute("disabled");
            loadMoreText.innerHTML = "Load More";
            loadingIcon.classList.add("hidden");
          }

          if (currentPageNew >= totalPages) {
            loadMoreButton.classList.add("hidden");
            loadingIcon.classList.add("hidden");
          }
        });
    }
  });
});
